export var TOTAL_COLUMNS = 12;
export var DEFAULT_COLUMN_SPAN = 12;
export var DEFAULT_GAP = {
  base: 'space/100',
  m: 'space/200'
};
export var DEFAULT_MARGIN_HORIZONTAL = {
  base: 'space/200',
  m: 'space/400',
  l: 'space/600'
};
//# sourceMappingURL=constants.js.map